// ===== Algolia sort orders: custom sortBy widget =====
// The app's own sort machinery ignores hook-activated sorts, so we
// remove the default sortBy widget and mount our own with the full
// index list. Replicas title_asc/title_desc are virtual replicas
// configured in the Algolia dashboard.
// NOTE: this file must load at the TOP of <head> WITHOUT defer,
// above {{ content_for_header }}.

/* ---- Collection browse mode ----
 * Wrapped in an IIFE because a bare top-level `return` is a SyntaxError
 * and would kill this entire file. Uses documentElement (not body)
 * because <body> does not exist yet when this runs in <head>.
 */
(function () {
  if (window.__algoliaCustomInit) return;
  window.__algoliaCustomInit = true;

  window.IS_COLLECTION = /^\/collections\//.test(location.pathname);

  if (window.IS_COLLECTION) {
    // Class hook for the CSS that hides the main search box + h1
    document.documentElement.classList.add('ais-browse-mode');

    // Strip stale ?q= so a shared/back-navigated URL doesn't silently
    // filter results with no visible box to explain it
    var u = new URL(location.href);
    if (u.searchParams.has('q')) {
      u.searchParams.delete('q');
      history.replaceState({}, '', u);
    }
  }
})();

(function () {
  function registerSortHooks() {
    // 1) Remove the app's default sortBy widget
    algoliaShopify.hooks.registerHook(
      'afterISStartRemoveDefaultWidget',
      function (defaultWidgets) {
        var sortWidget = defaultWidgets.find(function (w) {
          return w.$$widgetType === 'ais.sortBy';
        });
        return sortWidget ? [sortWidget] : [];
      }
    );

    // 2) Add our own sortBy widget into the same container
    algoliaShopify.hooks.registerHook(
      'beforeISStartAddWidgetArray',
      function () {
        var sortBy = window.algoliaShopify.externals.widgets.sortBy;
        return [
          sortBy({
            container: '.ais-sort',
            items: [
              { value: 'shopify_products',                              label: 'Relevance' },
              { value: 'shopify_products_recently_ordered_count_desc',  label: 'Most popular' },
              { value: 'shopify_products_title_asc',                    label: 'Name A–Z' },
              { value: 'shopify_products_title_desc',                   label: 'Name Z–A' },
              { value: 'shopify_products_published_at_desc',            label: 'Newest first' },
              { value: 'shopify_products_published_at_asc',             label: 'Oldest first' },
              { value: 'shopify_products_price_asc',                    label: 'Price: Low to High' },
              { value: 'shopify_products_price_dsc',                    label: 'Price: High to Low' }
            ]
          })
        ];
      }
    );
  }

  if (window.algoliaShopify && window.algoliaShopify.hooks) {
    registerSortHooks();
  } else {
    document.addEventListener('algolia.hooks.initialize', registerSortHooks);
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  var isRunning = false;
  var target = document.getElementById('algolia-shopify-instantsearch');
  var observer = null;

  // Show the facet search box only when a group has at least this many
  // options. Below it, the list is short enough to scan by eye.
  var SEARCHBOX_MIN_OPTIONS = 8;

  // Number of options shown before the Show All button appears.
  // Must match the nth-child rule in algolia_custom.css.
  var VISIBLE_OPTIONS = 4;

  // Results per page for each display mode. The app's own setting only
  // supports a single value, so the compact ("list") view is bumped
  // client-side — it fits ~6 per row instead of ~4.
  var HITS_GRID = 60;
  var HITS_COMPACT = 90;

  function simplifyStatsText() {
    var statsEl = document.querySelector('.ais-Stats-text');
    var countEl = document.querySelector('.ais-stats--nb-results');
    if (!statsEl || !countEl) return;

    var match = countEl.textContent.match(/[\d,]+/);
    if (!match) return;

    statsEl.style.display = 'none';

    var customEl = document.querySelector('.custom-items-count');
    if (!customEl) {
      customEl = document.createElement('span');
      customEl.className = 'custom-items-count';
      customEl.style.fontWeight = '700';
      customEl.style.fontSize = '0.95rem';
      customEl.style.color = '#222';
      statsEl.insertAdjacentElement('afterend', customEl);
    }
    var newText = match[0] + ' items';
    if (customEl.textContent !== newText) {
      customEl.textContent = newText;
    }

    var sortEl = document.querySelector('.ais-sort');
    if (sortEl) {
      for (var i = 0; i < sortEl.childNodes.length; i++) {
        var node = sortEl.childNodes[i];
        if (node.nodeType === 3 && node.textContent.trim().length > 0) {
          node.textContent = '';
        }
      }
    }
  }

  // Adds the Show All / Show Less toggle to groups with more options
  // than VISIBLE_OPTIONS, and removes a stale button when refinements
  // shrink a list below that threshold.
  function addShowAllButtons() {
    document.querySelectorAll('.ais-RefinementList').forEach(function (refinementEl) {
      var list = refinementEl.querySelector('.ais-RefinementList-list');
      var existing = refinementEl.querySelector('.custom-show-all-btn');

      if (!list) {
        if (existing) existing.remove();
        return;
      }

      if (list.children.length <= VISIBLE_OPTIONS) {
        if (existing) existing.remove();
        list.classList.remove('show-all');
        return;
      }

      if (existing) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'custom-show-all-btn';
      btn.textContent = 'Show All';

      btn.addEventListener('click', function () {
        var isShowingAll = list.classList.toggle('show-all');
        btn.textContent = isShowingAll ? 'Show Less' : 'Show All';
      });

      list.insertAdjacentElement('afterend', btn);
    });
  }

  // Hides the per-facet search box on short lists. Re-evaluated on every
  // render, so it reappears if refinements widen the list again.
  // setProperty(..., 'important') is needed because the CSS sets
  // display:block !important on the search box container.
  function toggleFacetSearchBoxes() {
    document.querySelectorAll('.ais-facets .ais-RefinementList').forEach(function (el) {
      var box = el.querySelector(
        '.ais-SearchBox, .ais-RefinementList-searchBox, .ais-facet--search-box'
      );
      if (!box) return;

      var list = el.querySelector('.ais-RefinementList-list');
      var count = list ? list.children.length : 0;

      if (count >= SEARCHBOX_MIN_OPTIONS) {
        box.style.removeProperty('display');
      } else {
        box.style.setProperty('display', 'none', 'important');
      }
    });
  }

  // Groups the search header into two independent containers:
  //  - .custom-header-left  → item count, filter chips, "Clear all" (wraps freely)
  //  - .custom-header-right → Sort By, View As (fixed, never wraps/moves)
  function organizeSearchHeader() {
    var searchHeader = document.querySelector('.ais-search-header');
    if (!searchHeader) return;

    var statsEl = document.querySelector('.ais-stats-container');
    var chipBar = document.querySelector('.ais-current-refined-values-container');
    var clearBar = document.querySelector('.ais-clear-refinements-container');
    var sortEl = document.querySelector('.ais-sort');
    var displayEl = document.querySelector('.ais-change-display');

    if (!statsEl || !chipBar || !sortEl || !displayEl) return;

    var leftWrap = searchHeader.querySelector('.custom-header-left');
    var rightWrap = searchHeader.querySelector('.custom-header-right');

    if (!leftWrap) {
      leftWrap = document.createElement('div');
      leftWrap.className = 'custom-header-left';
      searchHeader.insertBefore(leftWrap, searchHeader.firstChild);
    }
    if (!rightWrap) {
      rightWrap = document.createElement('div');
      rightWrap.className = 'custom-header-right';
      searchHeader.appendChild(rightWrap);
    }

    // appendChild on an existing node just moves it, so this is safe to
    // run on every mutation without duplicating anything.
    leftWrap.appendChild(statsEl);
    leftWrap.appendChild(chipBar);
    if (clearBar) leftWrap.appendChild(clearBar);

    rightWrap.appendChild(sortEl);
    rightWrap.appendChild(displayEl);

    if (leftWrap.parentElement !== searchHeader) searchHeader.insertBefore(leftWrap, searchHeader.firstChild);
    if (rightWrap.parentElement !== searchHeader) searchHeader.appendChild(rightWrap);

    var chipList = document.querySelector('.ais-current-refined-values--list');
    var hasChips = chipList && chipList.textContent.trim().length > 0;

    chipBar.classList.toggle('is-empty', !hasChips);
    if (clearBar) clearBar.classList.toggle('is-empty', !hasChips);
    chipBar.style.display = '';
    if (clearBar) clearBar.style.display = '';
  }

  // Collapsible facet groups: clicking a header toggles that group.
  // Delegated to #algolia-shopify-instantsearch rather than bound per
  // wrapper — the app re-renders the facet panel by replacing HTML,
  // which copies attributes but not listeners, so per-node binding
  // leaves nodes that look bound (data-collapseInit) but aren't.
  function initFacetCollapse() {
    var root = document.getElementById('algolia-shopify-instantsearch');
    if (!root || root.dataset.collapseDelegated) return;
    root.dataset.collapseDelegated = '1';

    root.addEventListener('click', function (e) {
      var header = e.target.closest('.ais-facet--header');
      if (!header) return;

      var wrap = header.closest('.ais-facet-dropdown-wrapper');
      if (!wrap) return;

      e.preventDefault();
      e.stopPropagation();
      wrap.classList.toggle('facet-collapsed');
      syncCollapseAllLabel();
    });
  }

  // Compact ("list") view fits more products per row, so ask Algolia for
  // more per page when it's active. The widget flips
  // .ais-change-display-selected between the two buttons; the
  // ais-results-size-* class does not change, so key off the former.
  // Delegated for the same reason as initFacetCollapse.
  function initViewHitsPerPage() {
    var root = document.getElementById('algolia-shopify-instantsearch');
    if (!root || root.dataset.hitsPerPageInit) return;
    root.dataset.hitsPerPageInit = '1';

    root.addEventListener('click', function (e) {
      if (!e.target.closest('.ais-change-display')) return;

      // let the widget flip .ais-change-display-selected first
      setTimeout(function () {
        var listBtn = document.querySelector('.ais-change-display-list');
        var compact = listBtn && listBtn.classList.contains('ais-change-display-selected');
        var want = compact ? HITS_COMPACT : HITS_GRID;

        var helper = window.algoliaShopify &&
          algoliaShopify.instantsearch &&
          algoliaShopify.instantsearch.search &&
          algoliaShopify.instantsearch.search.helper;
        if (!helper) return;

        if (helper.state.hitsPerPage !== want) {
          helper.setQueryParameter('hitsPerPage', want).search();
        }
      }, 0);
    });
  }

function addCollapseAllButton() {
    var facets = document.querySelector('.ais-facets');
    if (!facets) return;

    var btn = facets.querySelector('.custom-collapse-all');

    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'custom-collapse-all';
      facets.insertBefore(btn, facets.firstChild);

      btn.addEventListener('click', function () {
        var collapse = btn.dataset.action !== 'expand';
        facets
          .querySelectorAll('.ais-facet-dropdown-wrapper:not(.facet-empty)')
          .forEach(function (g) {
            g.classList.toggle('facet-collapsed', collapse);
          });
        syncCollapseAllLabel();
      });
    }

    syncCollapseAllLabel();
  }

  function syncCollapseAllLabel() {
    var facets = document.querySelector('.ais-facets');
    var btn = facets && facets.querySelector('.custom-collapse-all');
    if (!btn) return;

    var groups = facets.querySelectorAll(
      '.ais-facet-dropdown-wrapper:not(.facet-empty)'
    );
    var anyOpen = false;
    groups.forEach(function (g) {
      if (!g.classList.contains('facet-collapsed')) anyOpen = true;
    });

    btn.dataset.action = anyOpen ? 'collapse' : 'expand';
    btn.textContent = anyOpen ? 'Collapse all' : 'Expand all';
  }

  // 1) Hide facet groups with no options for the current result set.
  //    The Algolia app still renders the header + chevron when a facet
  //    returns no values. setProperty(..., 'important') is required
  //    because the CSS sets display:flex !important on the wrapper.
  //
  //    Range sliders render no list items at all, so a list-only
  //    selector reports them as populated forever. For those we check
  //    for slider handles instead — a slider with no matching products
  //    renders its track but no handles.
  //
  // 2) Collapse every remaining group the first time it's seen, so the
  //    panel loads compact. data-autoCollapsed makes it once-only, so a
  //    group the user opens stays open across re-renders.
  function hideEmptyFacets() {
    var OPTION_SELECTOR =
      '.ais-RefinementList-item, .ais-facet--item, .ais-RefinementList-label, ' +
      '.ais-Menu-item, .ais-HierarchicalMenu-item, .ais-NumericMenu-item';

    document
      .querySelectorAll('.ais-facets .ais-facet-dropdown-wrapper')
      .forEach(function (wrap) {
        var hasOptions = !!wrap.querySelector(OPTION_SELECTOR);

        if (!hasOptions) {
          var slider = wrap.querySelector(
            '.ais-RangeSlider, .ais-range-slider--target, .rheostat'
          );
          if (slider) {
            hasOptions = !!slider.querySelector(
              '.rheostat-handle, .ais-RangeSlider-handle, [class*="handle"]'
            );
          }
        }

        wrap.classList.toggle('facet-empty', !hasOptions);

        if (hasOptions) {
          wrap.style.removeProperty('display');
        } else {
          wrap.style.setProperty('display', 'none', 'important');
        }
      });

    document
      .querySelectorAll('.ais-facets .ais-facet-dropdown-wrapper:not(.facet-empty)')
      .forEach(function (wrap) {
        if (!wrap.dataset.autoCollapsed) {
          wrap.dataset.autoCollapsed = '1';
          wrap.classList.add('facet-collapsed');
        }
      });
  }

  function runAll() {
    if (isRunning) return;
    isRunning = true;
    if (observer) observer.disconnect();

    simplifyStatsText();
    addShowAllButtons();
    toggleFacetSearchBoxes();
    organizeSearchHeader();
    initFacetCollapse();
    initViewHitsPerPage();
    hideEmptyFacets();
    addCollapseAllButton();

    if (observer && target) {
      observer.observe(target, { childList: true, subtree: true });
    }
    isRunning = false;
  }

  window.__aisRunAll = runAll;

  runAll();

  if (target) {
    observer = new MutationObserver(function () {
      runAll();
    });
    observer.observe(target, { childList: true, subtree: true });
  }
});